import { Howl, Howler } from "howler";
import { SliderManager } from "././SliderOperator";

let regionSound = null;
let regionSoundUrl = null;
let regionSoundFilter = null;
let regionSoundSource = null;

export const RegionAudioManager = {
  handleRegionMusic(url, time = 0) {
    if (regionSound) {
      this.fadeOut(regionSound, () => {
        this.cleanupRegionSound();
        this.createRegionSound(url, time);
      });
    } else {
      this.createRegionSound(url, time);
    }
  },

  createRegionSound(url, time) {
    regionSound = new Howl({
      src: [url],
      volume: 0, 
      html5: true,
      loop: true,
      onplayerror: () => regionSound.once("unlock", () => regionSound.play())
    });

    regionSoundUrl = url;

    regionSound.once("play", () => {
      const soundObj = regionSound._sounds[0];
      const node = soundObj && soundObj._node;
      if (node instanceof Audio) {
        const ctx = Howler.ctx;

        if (regionSoundSource) regionSoundSource.disconnect();
        if (regionSoundFilter) regionSoundFilter.disconnect();

        regionSoundSource = ctx.createMediaElementSource(node);
        regionSoundFilter = ctx.createBiquadFilter();
        regionSoundFilter.type = "lowpass";
        regionSoundFilter.frequency.setValueAtTime(22050, ctx.currentTime);

        regionSoundSource.connect(regionSoundFilter);
        regionSoundFilter.connect(ctx.destination);
      }
    });

    regionSound.play();
    regionSound.seek(time);

    const targetVolume = SliderManager.volumeRegion * SliderManager.volumeMaster;
    this.fadeIn(regionSound, targetVolume);
  },

  stopRegionMusic() {
    if (regionSound) {
      this.fadeOut(regionSound, () => {
        this.cleanupRegionSound();
      });
    }
  },

  cleanupRegionSound() {
    if (regionSound) {
      try { regionSound.stop(); } catch {}
      try { regionSound.unload(); } catch {}
    }
    regionSound = null;
    regionSoundUrl = null;
    if (regionSoundSource) regionSoundSource.disconnect();
    if (regionSoundFilter) regionSoundFilter.disconnect();
    regionSoundSource = null;
    regionSoundFilter = null;
  },

  enableMuffleEffect() {
    if (regionSoundFilter) {
      regionSoundFilter.frequency.setValueAtTime(400, Howler.ctx.currentTime);
    }
  },

  disableMuffleEffect() {
    if (regionSoundFilter) {
      regionSoundFilter.frequency.setValueAtTime(22050, Howler.ctx.currentTime);
    }
  },

  fadeOut(audio, callback) {
    const steps = 10;
    const interval = 200;
    let index = 0;
    const startVol = audio.volume();

    const fader = setInterval(() => {
      index++;
      audio.volume(startVol * (1 - index / steps));
      if (index >= steps) {
        clearInterval(fader);
        if (callback) callback();
      }
    }, interval);
  },

  fadeIn(audio, targetVolume) {
    const steps = 10;
    const interval = 200;
    let index = 0;

    const fader = setInterval(() => {
      index++;
      const liveTarget = SliderManager.volumeRegion * SliderManager.volumeMaster;
      audio.volume(liveTarget * (index / steps));
      if (index >= steps) clearInterval(fader);
    }, interval);
  },

  updateRegionVolume(volume) {
    if (regionSound) {
      regionSound.volume(volume);
    }
  }
};
